<div class="schedule-g1-modal">
<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  
  <!-- Loading Spinner -->
  @if (dataLoading) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
    <div class="loading-text">Loading Schedule G1 data...</div>
  </div>
}

  @if (!dataLoading) {
<div class="form-horizontal">
    
    <!-- Header Label -->
    <div class="form-group">
      <div class="col-md-6">
        <label>CSA-1</label>
      </div>
    </div>

    <!-- Schedule G1 Table -->
    <table class="table table-bordered form-inline custom-table">
      <tbody>
        @for (row of irsF5471ScheduleG1Data; track $index; let i = $index) {
<tr 
            style="padding-bottom: 0 !important;" 
            [hidden]="row.line_no === 'FormNo'">
          <td style="padding-left: 5px !important;">{{row.line_no}}.</td>
          <td style="padding-left: 5px !important;">
            {{row.line_description}}
            
            <!-- Line 1: Textarea -->
            @if (row.line_no === '1' && !isArray(row.value) && row.value) {
<span>
              <br>
              <div class="col-md-10" style="padding-top: 5px">
                <textarea 
                  cols="110" 
                  maxlength="4000" 
                  wrap="hard" 
                  rows="4" 
                  [(ngModel)]="row.value.VALUE" 
                  class="form-control custom-textarea">
                </textarea>
              </div>
            </span>
}
            
            <!-- Line 5c: Checkboxes -->
            @if (row.line_no === '5c') {
<span>
              <br>
              <div class="radioBtnPosition">
                Comparable uncontrolled transaction method
                <input 
                  style="margin-left: 5px" 
                  type="checkbox" 
                  name="lineNumber5c_comparable" 
                  [checked]="row.value_comparable?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxChange(row, 'comparable', $event, i)"/>
              </div>
              
              <div class="radioBtnPosition">
                Income method
                <input 
                  style="margin-left: 5px" 
                  type="checkbox" 
                  name="lineNumber5c_income" 
                  [checked]="row.value_income?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxChange(row, 'income', $event, i)"/>
              </div>
              
              <div class="radioBtnPosition" style="margin-left: 67px">
                Acquisition price method
                <input 
                  style="margin-left: 5px" 
                  type="checkbox" 
                  name="lineNumber5c_acquisition" 
                  [checked]="row.value_acquisition?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxChange(row, 'acquisition', $event, i)"/>
                <br>
              </div>
              
              <div class="radioBtnPosition">
                Market capitalization method
                <input 
                  style="margin-left: 5px" 
                  type="checkbox" 
                  name="lineNumber5c_market" 
                  [checked]="row.value_market?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxChange(row, 'market', $event, i)"/>
              </div>
              
              <div class="radioBtnPosition" style="margin-left: 97px">
                Residual profit split method
                <input 
                  style="margin-left: 5px" 
                  type="checkbox" 
                  name="lineNumber5c_residual" 
                  [checked]="row.value_residual?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxChange(row, 'residual', $event, i)"/>
              </div>
              
              <div class="radioBtnPosition">
                Unspecified methods
                <input 
                  style="margin-left: 5px" 
                  type="checkbox" 
                  name="lineNumber5c_unspecified" 
                  [checked]="row.value_unspecified?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxChange(row, 'unspecified', $event, i)"/>
              </div>
            </span>
}
          </td>
          
          <!-- Right Column - Radio buttons or Text input -->
          <td class="col-md-1" style="padding-left: 5px !important; align-items: center">
            
            <!-- Property Type 13: Radio Buttons (Yes/No) -->
            @if (row.propertyType === '13' && isArray(row.value)) {
<div class="radio-container">
              <div class="radioBtnPosition col-md-4">
                Yes 
                <input 
                  type="radio" 
                  style="margin-left: 5px" 
                  [value]="'Y'" 
                  [name]="'radio_' + row.line_no" 
                  class="radio"
                  [checked]="row.value && row.value[0] && row.value[0].VALUE === 'Y'"
                  [disabled]="row.isEditableFlag === 'N' || (row.value && row.value[0] && row.value[0].disabled)"
                  (change)="isArray(row.value) && row.value[0] ? row.value[0].VALUE = 'Y' : undefined; onRadioBtnSelection(row, i, 'Y'); checkingForValidation(row, i)">
              </div>
              
              <div class="radioBtnPosition col-md-4">
                No 
                <input 
                  type="radio" 
                  style="margin-left: 5px" 
                  [value]="'N'" 
                  [name]="'radio_' + row.line_no" 
                  class="radio"
                  [checked]="row.value && row.value[1] && row.value[1].VALUE === 'N'"
                  [disabled]="row.isEditableFlag === 'N' || (row.value && row.value[1] && row.value[1].disabled)"
                  (change)="isArray(row.value) && row.value[1] ? row.value[1].VALUE = 'N' : undefined; onRadioBtnSelection(row, i, 'N'); checkingForValidation(row, i)">
              </div>
            </div>
}
            
            <!-- Property Type 7: Text Input -->
            @if (row.propertyType === '7' && !isArray(row.value) && row.value) {
<div>
              <input 
                onlyIntegersWithLength
                style="text-align: right; align-items: center; padding-left: 5px" 
                type="text" 
                class="form-control" 
                [name]="'input_' + row.line_no"
                [disabled]="row.isEditableFlag === 'N'" 
                [(ngModel)]="row.value.VALUE"
                (click)="checkingForValidation(row, i)"/>
            </div>
}
          </td>
        </tr>
}
      </tbody>
    </table>
    
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button 
    class="save-button" 
    type="button" 
    [disabled]="crudLoading"
    (click)="saveScheduleG1Form()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button 
    class="cancel-button" 
    type="button"
    (click)="cancel()">Cancel</button>
</div>
</div>

